import React from "react";
import s from "./index.module.scss";
import classNames from "classnames/bind";
const cx = classNames.bind(s);

const ContentWrapper = ({ as, children, className }) => {
	const TagName = as || "div";

	return (
		<TagName className={cx(className, s.contentWrapper)}>
			{children}
		</TagName>
	);
};

export default ContentWrapper;
